import { main } from "./main";
import { top } from "./top";
import { kyou } from "./kyou";

main();
top();
kyou();
